import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Messages } from 'src/app/constants/messages';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-feature-modal',
  templateUrl: './feature-modal.component.html',
  styleUrls: ['./feature-modal.component.css']
})
export class FeatureModalComponent implements OnInit, OnDestroy {

  @ViewChild("values", { static: false }) valueRef: ElementRef | undefined;

  @Input() featureData: any;
  @Input() featureAdd: any;
  @Input() featureView: any;
  @Input() featureEdit: any;

  featureForm: FormGroup;
  type: any;
  menuType: any;
  formSubmitted: boolean = false;
  errorMessage: any = null;

  private _loading: boolean = false;
  private _colorList: any = ['#000', '#999', '#e3e3e3', '#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', ' #E0BBE4', '#957DAD', '#90CCDE']
  private _afterClosedSubscription: Subscription;
  private _saveFeatureSubscription: Subscription;
  private _saveSubscription: Subscription;

  
  constructor(
    private _activeModal: NgbActiveModal,
    private _fb: FormBuilder,
    private _service: ServicecallService,
    private _datepipe: DatePipe,
    private _dialog: MatDialog
  ) {
    this.featureForm = this._fb.group({
      menu: ['', [Validators.required]],
      featureName: ['', [Validators.required]],
      featureType: [],
      featureDescription: ['', [Validators.required]],
      featureReleasedOn: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this._loadConfigurationModalData();
  }
  ngOnDestroy(): void {
    this._afterClosedSubscription?.unsubscribe();
    this._saveFeatureSubscription?.unsubscribe();  
    this._saveSubscription?.unsubscribe();    
  }
  closeModal() {
    if (this.featureForm.dirty) {
      let dialogRef = this._dialog.open(AlertDialogComponent, {
        data: { msg: Messages.UNSAVED_CHANGES, type: null },
        disableClose: true
      });
      this._afterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this._activeModal.close();
        }
      });
    }
    else {
      this._activeModal.close();
    }
  }
  onSubmit() {
    if (this.featureForm.invalid) {
      return;
    }
    if (this.featureEdit) {
      this._editPrivilege();
    } else {
      this._addPrivilege();
    }
  }
  get formValues() {
    return this.featureForm.controls;
  }
  private _checkDate(x: any) {
    if (x) {
      return new Date(x)
    }
    return x;
  }

  private _loadConfigurationModalData() {
    this.type = this._service.getConfiguration('featureType') ? this._service.getConfiguration('featureType').FeatureType : [];
    this.menuType = this._service.getConfiguration('menu') ? this._service.getConfiguration('menu').menu : [];
    if (this.featureEdit) {
      let data = JSON.stringify(this.featureData);
      this.featureData.featureReleasedOn = this._checkDate(JSON.parse(data).featureReleasedOn);
    } else if (this.featureView) {
      let data = JSON.stringify(this.featureData);
      this.featureData.featureReleasedOn = this._checkDate(JSON.parse(data).featureReleasedOn);
    }
    if (this.featureData) {
      if (this.featureView) {
        this.featureForm.disable();
      }
    }
    this._patchValues();
  }

  //   this._loading = true;
  //   this._service.configurationsInfo(this.attributes).subscribe((results: any) => {
  //     this._loading = false;
  //     let configList: any = results["response"];
  //     configList.forEach((element: any) => {
  //       if (element["attribute"] === "featureType") {
  //         this.type = element['values'].FeatureType;
  //       }
  //       if (element["attribute"] === "menu") {
  //         this.menuType = element['values'].menu;
  //       }
  //     })
  //     if (this.featureEdit) {
  //       let data = JSON.stringify(this.featureData);
  //       this.featureData.featureReleasedOn = this.checkDate(JSON.parse(data).featureReleasedOn);
  //     } else if (this.featureView) {
  //       let data = JSON.stringify(this.featureData);
  //       this.featureData.featureReleasedOn = this.checkDate(JSON.parse(data).featureReleasedOn);
  //     }
  //     if (this.featureData) {
  //       if (this.featureView) {
  //         this.featureForm.disable();
  //       }
  //     }
  //     this.patchValues();
  //   });
  // }

  private _patchValues() {
    if (this.featureAdd) {
      this.featureForm.patchValue({ menu: this.featureForm.value.menu, featureName: this.featureForm.value.featureName, featureReleasedOn: this.featureForm.value.featureReleasedOn, featureType: this.featureForm.value.featureType, featureDescription: this.featureForm.value.featureDescription });
    } else {
      this.featureForm.patchValue({
        menu: this.featureData.menu, featureName: this.featureData.featureName, featureReleasedOn: this.featureData.featureReleasedOn, featureType: this.featureData.featureType, featureDescription: this.featureData.featureDescription
      });
    }
  }
  private _addPrivilege() {
    this.errorMessage = null;
    this.formSubmitted = true;
    this._loading = true;
    let featureDetails: any;
    featureDetails = {
      menu: this.featureForm.value.menu,
      featureName: this.featureForm.value.featureName,
      featureReleasedOn: this._datepipe.transform(this.featureForm.value.featureReleasedOn, 'yyyy-MM-dd'),
      featureType: this.featureForm.value.featureType,
      featureDescription: this.featureForm.value.featureDescription
    }
    this._saveFeatureSubscription = this._service.saveFeature(featureDetails, 'add').subscribe((result: any) => {
      this.formSubmitted = false;
      if (result["status"] && result["response"]) {
        if (result["status"]) {
          this._service.toasterService({ type: 'success', msg: result['response']['message'] });
          this._loading = false;
          this._activeModal.close(true);
        } else {
          this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
          // this._service.toasterService({ type: 'error', msg: result['response']['message'] });
          this._loading = false;
        }
      } else {
        if (result["response"]) {
          this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
          // this._service.toasterService({ type: 'error', msg: result['response']['message'] });
          this._loading = false;
        }
      }
    })
  }

  private _editPrivilege() {
    this.errorMessage = null;
    this.formSubmitted = true;
    this._loading = true;
    let featureDetails: any;
    featureDetails = {
      menu: this.featureForm.value.menu ? this.featureForm.value.menu : this.featureData.menu,
      featureName: this.featureForm.value.featureName ? this.featureForm.value.featureName : this.featureData.featureName,
      featureReleasedOn: this.featureForm.value.featureReleasedOn ? this._datepipe.transform(this.featureForm.value.featureReleasedOn, 'yyyy-MM-dd') : this._datepipe.transform(this.featureData.featureReleasedOn, 'yyyy-MM-dd'),
      featureType: this.featureForm.value.featureType ? this.featureForm.value.featureType : this.featureData.featureType,
      featureDescription: this.featureForm.value.featureDescription ? this.featureForm.value.featureDescription : this.featureData.featureDescription
    }
    this._saveSubscription = this._service.saveFeature(featureDetails, 'update', this.featureData["_id"]).subscribe((result: any) => {
      this.formSubmitted = false;
      if (result["status"] && result["response"]) {
        if (result["status"]) {
          this._service.toasterService({ type: 'success', msg: result['response']['message'] });
          this._loading = false;
          this._activeModal.close(true);
        } else {
          this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
          // this._service.toasterService({ type: 'error', msg: result['response']['message'] });
          this._loading = false;
        }
      } else {
        if (result["response"]) {
          this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
          // this._service.toasterService({ type: 'error', msg: result['response']['message'] });
          this._loading = false;
        }
      }
    })
  }

}
